var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-h4 mb-10"},[_c('div',[_vm._v("Alterar senha")]),_c('UpdatePasswordForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }